import React from 'react';
import PropTypes from 'prop-types';
import {Radio} from 'lark';
import ExplainHeader from '~/component/login/H5/ExplainHeader';
import './index.less';

const H5HelpCenter = props => {
    const {radio, onChange, children} = props;
    return (
        <div className="h5-help-wrapper">
            <ExplainHeader class="help-explain-header">帮助中心</ExplainHeader>
            <nav className="help-nav">
                <Radio.Group onChange={onChange} value={radio}>
                    <Radio.Button value="login">登录</Radio.Button>
                    <Radio.Button value="safe">安全验证</Radio.Button>
                </Radio.Group>
            </nav>
            <main className="help-main">
                {children}
            </main>
        </div>
    );
};

H5HelpCenter.propTypes = {
    radio: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.shape().isRequired,
};


export default H5HelpCenter;
